var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    fill: "url(#pattern0_13932_75366)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_13932_75366",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13932_75366",
    transform: "matrix(0.02 0 0 0.0213333 0 -0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13932_75366",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACXklEQVR4nO2XX27TQBDG9x2QAAGCExQCLdAZR6XiX+/AARAUDsIBQOIGPUH7SOKZmrR9rwRVCUU8wAkAqWDvPhiNnUQiNI5jy9kF7SeNFDm7M/vbbz22lfLy8qqlNAouG4J9w5haCYJ9WUM9iM7SJUNwYA2CRzD9tAdXqkHs3LpoCN5bh+AaMBkE4zvri+dxGPxQ+5iVlQ7h7rQFacZV9S9IE/yYDAHf57YQU9F6HS2v5CC4VeDGZjYmDO5UraOaBjEMr2R+TO2W7PwJEN/iCK5mNQhfOwuiCX4JxAiGcEuA8sDNuHv7mvyXhLCoGWNnQUy+61+GMCcp4eC6Zvhap4aaB8jAmZ+G8KUOMUg7S6ckNEFbjp64Vje/mhdI06E8CNt3wXhH2P7OG9uOaMJOQrAeMy4Mu5Y8CBMOnmnGrvsgBH1Ny/em5dcc3DcMH90EIXibRjfPlq2R7i6eMwQ9t0AI+pMgiopnMAxH7oCE8HBaruJj5gCIZuyWyVU0RhOQdZCE4GltkG18bh0kZlyoCyKt2TpIurd6ZuICqd0qU1xyOAuSUPBYMx4Pxh06DxKPHa382wM3Rs2AcEOuFdWTL0frIAnB+h9zCR5lAIzHCeOTMvWcuNk1Q/jXfMIXSYQ3ytbThGwdxEgQrJVOPg6xjQ9mracaA2H4nEZwYVaI9M3KeUP4ySEQFFd68u40EwTjTpVaqlGQ3JmjoveuUX6CtSpOmPmBDBoAAUknkraaRq3TEvJbrs16YxubIE2H8iBs3wXjHWH7O2+8IwP9P44Q7tlerJkcu6VBvLy81FC/AQg8xF1wK9g5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/received.4f3688264e48ec23f39ce39794824d56.svg";
export { ForwardRef as ReactComponent };